var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTumblrNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2 48C22 48 16.6 44.3 16.6 35.4V21.2H10V13.5C17.2 11.6 20.2 5.4 20.6 0H28.1V12.2H36.8V21.2H28.1V33.6C28.1 37.3 30 38.6 33 38.6H37.2V48H29.2Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2,
    height: 48,
    fill: "current",
    transform: "translate(10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblrNegative);
export default __webpack_public_path__ + "static/media/Tumblr - Negative.b31a216c83db45364bf8d20727d83892.svg";
export { ForwardRef as ReactComponent };